export default __webpack_public_path__ + "static/iso-black-divas-fc0c84b90c607976ffce88d316557523.jpeg";